<template>
    <div>
        <div class="w-100 mb-4">
            <div class="float-left p-1 mr-2 mb-2" style="border: 1px solid #AAA; width: 25%; background-color:#eee;">
                <select2 ref="timeRangeSelect"
                         name="timeRangeSelect"
                         key="timeRangeSelect"
                         :options="timeRangeFilters"
                         key-property="value"
                         text-property="text"
                         disable-search
                         css-class="form-control-sm"
                         dropdownCssClass="small"
                         v-model="selectedTimeRangeFilter"
                         v-on:select="timeRangeFilterChanged">
                </select2>
                <select2 ref="employmentTypeSelect"
                         name="employmentTypeSelect"
                         key="employmentTypeSelect"
                         :options="employmentTypes"
                         key-property="value"
                         text-property="text"
                         disable-search
                         css-class="form-control-sm mt-1"
                         dropdownCssClass="small"
                         v-model="selectedEmploymentType"
                         v-on:select="employmentTypeSelectionChanged">
                </select2>
                <select2 ref="skillLevel"
                         name="skillLevel"
                         key="skillLevel"
                         :options="skillLevels"
                         key-property="value"
                         text-property="text"
                         disable-search
                         css-class="form-control-sm mt-1"
                         dropdownCssClass="small"
                         v-model="selectedSkillLevel"
                         v-on:select="skillLevelSelectionChanged">
                </select2>
            </div>

            <div class="float-left p-1" style="border: 1px solid #bbb; width: 35%; background-color:#eee;">

                <b-form-group class="w-25 float-left pl-1">
                    <b-form-radio v-model="selectedOrganisation" @change="radioChanged('court')" size="sm" value="court">Court</b-form-radio>
                    <b-form-radio v-model="selectedOrganisation" @change="radioChanged('interview')" size="sm" value="interview">Interview</b-form-radio>
                </b-form-group>

                <b-form-group label-for="selectGroup" label="" class="float-left w-75 m-0">
                    <select2 ref="courtRegistrySelect"
                             name="courtRegistrySelect"
                             key="courtRegistrySelect"
                             placeholder="Select a Registry"
                             :options="courtRegistries"
                             key-property="courtRegistryId"
                             text-property="name"
                             allow-clear
                             :disabled="selectedOrganisation=='interview'"
                             v-if="selectedOrganisation=='court'"
                             css-class="form-control-sm"
                             dropdownCssClass="small"
                             v-model="courtRegistryId"
                             v-on:select="courtRegistrySelectionChanged"></select2>

                    <select2 ref="interviewOrganisationSelect"
                             name="interviewOrganisationSelect"
                             key="interviewOrganisationSelect"
                             placeholder="Select an Organisation"
                             :options="interviewOrganisations"
                             key-property="interviewOrganisationId"
                             text-property="name"
                             allow-clear
                             :disabled="selectedOrganisation=='court'"
                             v-if="selectedOrganisation=='interview'"
                             css-class="form-control-sm"
                             dropdownCssClass="small"
                             v-model="interviewOrganisationId"
                             v-on:select="interviewOrganisationSelectionChanged"></select2>

                    <select2 ref="courtLocationSelect"
                             name="courtLocationSelect"
                             key="courtLocationSelect"
                             placeholder="Select a Location"
                             :options="courtLocations"
                             key-property="courtLocationId"
                             text-property="name"
                             allow-clear
                             v-if="selectedOrganisation=='court'"
                             css-class="form-control-sm mt-1"
                             dropdownCssClass="small"
                             v-model="courtLocationId"
                             v-on:select="courtLocationSelectionChanged"></select2>

                    <select2 ref="timeZoneSelect"
                             name="timeZoneSelect"
                             key="timeZoneSelect"
                             placeholder="Select a time zone"
                             :options="timeZones"
                             key-property="value"
                             text-property="name"
                             disable-search
                             allow-clear
                             css-class="form-control-sm mt-1"
                             dropdownCssClass="small"
                             v-model="timeZoneId"
                             v-on:select="timeZoneSelectionChanged"></select2>
                </b-form-group>
            </div>

            <div class="float-left ml-2">
                <b-button @click="loadAvailability" size="sm" :variant="filtersChanged ? 'success' : 'secondary'" class="mr-2">Apply filters</b-button>
            </div>

            <div class="float-right">
                <b-button @click="gotoWeek(-1)" variant="warning" class="mr-2"><i class="fas fa-caret-square-left"></i></b-button>
                <b-button @click="gotoWeek(0)" class="mr-2" variant="warning"><i class="fas fa-calendar-day"></i></b-button>
                <b-button @click="gotoWeek(+1)" class="mr-2" variant="warning"><i class="fas fa-caret-square-right"></i></b-button>
            </div>

            <div class="float-right mr-4 smaller">
                TVL: Available for Travel<br>
                O/S: Available for On Site<br>
                RT:  Available for Real Time
            </div>
        </div>

        <br style="clear:both;">
        <div style="padding:0 10px 0 10px;" v-if="availabilityWeeksAccumulated && availabilityWeeksAccumulated.weeks">
            <b-row v-for="(week,index) in availabilityWeeksAccumulated.weeks" :key="index">
                <div class="float-left" style="font-size:22px; width: 130px;">Week {{ week.weekNr }}</div>
                <div class="float-left"></div>

                <b-table-simple class="text-center m-10"
                                fixed
                                bordered
                                small
                                style="float: right; margin-bottom: 20px;">
                    <b-thead>
                        <b-tr>
                            <b-th class="align-middle">Date</b-th>
                            <b-th v-for="(dayObj,dayIndex) in week.days" :key="dayIndex">
                                <b-button class="w-100 p-1 mb-1" size="sm" @click="showDayAccumulatedModal(null, dayObj.date)" variant="info">{{ formatDateTime(dayObj.date, 'ddd DD/MM/YYYY', true, true) }}</b-button>
                            </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tr>
                        <b-td class="align-middle"><strong>{{ cleanedTimeText }}</strong></b-td>
                        <b-td v-for="(dayObj,dayIndex) in week.days" :key="dayIndex">
                            <template v-for="(role,roleIndex) in dayObj.roles">
                                <span :key="roleIndex" v-if="isRoleRelevant(role.roleId)" class="d-inline-block mr-1 position-relative" style="max-width: 40px;">
                                    <b-link @click="showDayAccumulatedModal(role.roleId, dayObj.date)"><img :src="getRoleImageUrl(role.roleId)" :alt="role.roleDisplayName" :title="role.roleDisplayName" class="img-thumbnail img-fluid" /></b-link>
                                    <b-badge :variant="getAvailabilityLevelVariant(role.availabilityLevel)" pill class="position-absolute" style="bottom:0;right:0;">{{ role.count }}</b-badge>
                                </span>
                            </template>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td class="align-middle">
                            <strong>Delayed (audio mins)</strong>
                        </b-td>
                        <b-td v-for="(dayObj,index) in week.days" :key="index">
                            <span class="d-inline-block mr-1 position-relative" style="max-width: 40px;">
                                <b-link @click="showOptionsAccumulatedModal('delayedMinutesView',dayObj.date)"><img :src="imagesUrl + 'clock_icon.png'" alt="Transcript Delayed" title="Transcript Delayed" class="img-fluid img-thumbnail" /></b-link>
                                <b-badge :variant="getAvailabilityLevelVariant(dayObj.delayedAvailabilityLevel)" pill class="position-absolute" style="bottom:0;right:0;">{{ dayObj.delayedUsers }}</b-badge>
                            </span>
                            {{ dayObj.audioMinutes }} mins
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td class="align-middle"><strong>Options</strong></b-td>
                        <b-td v-for="(dayObj,index) in week.days" :key="index">
                            <b-link @click="showOptionsAccumulatedModal('optionsView',dayObj.date)">{{ dayObj.availableForTravel }}xTVL  {{ dayObj.availableForOnSite }}xO/S  {{ dayObj.availableForRealTime }}xRT</b-link>
                        </b-td>
                    </b-tr>
                </b-table-simple>
            </b-row>

            <availability-day-accumulated :api-assignment-controller-url="apiAssignmentControllerUrl"
                                          :api-controller-url=apiControllerUrl
                                          :images-url="imagesUrl"
                                          :relevant-roles="relevantRoles"
                                          :checked-roles="checkedRoles"
                                          :title="modalTitle"
                                          :relevant-date="dateToShow"
                                          v-model="showDayModal"
                                          :assignment-mode="false"
                                          :employmentType="appliedEmploymentType"
                                          :skillLevel="appliedSkillLevel"
                                          :timeRangeFilter="appliedTimeRangeFilter"
                                          :court-registry-id="appliedCourtRegistryId"
                                          :interview-organisation-id="appliedInterviewOrganisationId"
                                          :entity-display-string="appliedEntityDisplayString"
                                          :timeZoneId="timeZoneId">
            </availability-day-accumulated>

            <availability-options-accumulated :api-assignment-controller-url="apiAssignmentControllerUrl"
                                              :api-controller-url=apiControllerUrl
                                              :images-url="imagesUrl"
                                              :relevant-roles="relevantRolesForOptionsAccumulated"
                                              :checked-roles="checkedRoles"
                                              :title="modalTitle"
                                              :relevant-date="dateToShow"
                                              v-model="showOptionsModal"
                                              :assignment-mode="false"
                                              :employmentType="appliedEmploymentType"
                                              :skillLevel="appliedSkillLevel"
                                              :timeRangeFilter="appliedTimeRangeFilter"
                                              :court-registry-id="appliedCourtRegistryId"
                                              :interview-organisation-id="appliedInterviewOrganisationId"
                                              :entity-display-string="appliedEntityDisplayString"
                                              :timeZoneId="timeZoneId"
                                              :only-check-options="onlyCheckOptions">
            </availability-options-accumulated>

            <!--
        <availability-delayed-assignment  :api-assignment-controller-url="apiAssignmentControllerUrl"
                                          :api-controller-url=apiControllerUrl
                                          :images-url="imagesUrl"
                                          :relevant-roles="getCheckedRolesForDelayedAssignment()"
                                          :checked-roles="checkedRoles"
                                          title="Delayed audio minutes assignment"
                                          :start-date="dateToShow"
                                          v-model="showDelayedModal"
                                          :assignment-mode="false"
                                          :employment-type="appliedEmploymentType"
                                          :skillLevel="appliedSkillLevel"
                                          :time-range-filter="appliedTimeRangeFilter"
                                          :court-registry-id="appliedCourtRegistryId"
                                          :interview-organisation-id="appliedInterviewOrganisationId"
                                          :time-zone-id="timeZoneId">
        </availability-delayed-assignment> -->
        </div>

        <div class="d-flex justify-content-center">
            <b-spinner variant="secondary" label="Loading..." v-if="showSpinner"></b-spinner>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue } from 'bootstrap-vue'
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import UserMixin from '../../mixins/UserMixin';
    import Select2 from '../Select2';
    import AvailabilityDayAccumulated from './AvailabilityDayAccumulated';
    // import AvailabilityDelayedAssignment from './AvailabilityDelayedAssignment';
    import AvailabilityOptionsAccumulated from './AvailabilityOptionsAccumulated'

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);

    export default {
        name: 'AvailabilityWeeksAccumulated',
        mixins: [ErrorsMixin, DateTimeMixin, UserMixin],
        components: {
            AvailabilityDayAccumulated,
            // AvailabilityDelayedAssignment
            AvailabilityOptionsAccumulated

        },
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            apiAssignmentControllerUrl: {
                type: String,
                required: true
            },
            imagesUrl: {
                type: String,
                required: true
            },
            relevantRoles: {
                type: Array,
                required: true
            }
        },
        data: function () {
            return {
                relevantRolesForOptionsAccumulated: [
                    { "role": 16, "roleId": 16, "roleDisplayName": "Stenographer" },
                    { "role": 32, "roleId": 32, "roleDisplayName": "Transcriber" },
                    { "role": 64, "roleId": 64, "roleDisplayName": "Monitor" },
                    { "role": 8192, "roleId": 8192, "roleDisplayName": "Editor" },
                    { "role": 16384, "roleId": 16384, "roleDisplayName": "Merger" },
                    { "role": 128, "roleId": 128, "roleDisplayName": "Coordinator" },
                    { "role": 256, "roleId": 256, "roleDisplayName": "Monitoring Supervisor" }
                ],
                onlyCheckOptions: false,
                showSpinner: false,
                availabilityWeeksAccumulated: null,
                dayByRoleAvailability: null,
                filtersChanged: false,
                dateToShow: null,
                showDayModal: false,
                showRoleModal: false,
                modalTitle: null,
                roleAvailabilityModalTitle: null,
                checkedRoles: null,
                modalDate: null,
                cleanedTimeText: '08:00-18:00',
                timeRangeFilters: null,
                selectedEmploymentType: null,
                employmentTypes: null,
                interviewOrganisations: null,
                interviewOrganisationDisplayString: '',
                selectedInterviewOrganisation: null,
                interviewOrganisationId: null,
                courtRegistries: null,
                courtRegistryDisplayString: '',
                selectedCourtRegistry: null,
                courtRegistryId: null,
                courtLocations: null,
                selectedCourtLocation: null,
                courtLocationId: null,
                timeZoneId: null,
                timeZones: null,
                skillLevels: null,
                skillLevelId: null,
                selectedSkillLevel: null,
                selectedTimeRangeFilter: null,
                selectedOrganisation: 'court',
                // variables to be passed into AvailabilityDayAccumulated Modal
                appliedEmploymentType: null,
                appliedSkillLevel: null,
                appliedTimeRangeFilter: null,
                appliedCourtRegistryId: null,
                appliedInterviewOrganisationId: null,
                appliedEntityDisplayString: null,
                // delayed assignment stuff
                // showDelayedModal:false
                showOptionsModal: false
            }
        },

        methods: {

            getCheckedRolesForDelayedAssignment: function () {
                var roleArrayCopy =  this.relevantRoles;
                return roleArrayCopy;
            },

            timeRangeFilterChanged: function () {
                var timeText = new String(this.timeRangeFilters.find(x => x.value === this.selectedTimeRangeFilter).text);
                var pos1 = timeText.indexOf('(');
                var pos2 = timeText.indexOf(')');
                this.cleanedTimeText = timeText.slice(pos1 + 1, pos2);
                this.filtersChanged = true;
            },

            gotoWeek: function (val) {
                if (!this.availabilityWeeksAccumulated) return;
                if (val < 0) {
                    if (!this.availabilityWeeksAccumulated.previousWeek) return;
                    this.startWeek = { year: this.availabilityWeeksAccumulated.previousWeek.year, weekNr: this.availabilityWeeksAccumulated.previousWeek.weekNr };
                } else if (val > 0) {
                    if (!this.availabilityWeeksAccumulated.weeks) return;
                    this.startWeek = { year: this.availabilityWeeksAccumulated.weeks[1].year, weekNr: this.availabilityWeeksAccumulated.weeks[1].weekNr };
                } else {
                    this.startWeek = null;
                }
                this.loadAvailability();
            },

            loadTimeRangeFilters: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "timeranges";
                return axios
                    .get(url)
                    .then(response => {
                        this.timeRangeFilters = response.data;
                        this.selectedTimeRangeFilter = 'BusinessHours';
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            loadInterviewOrganisations: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "intervieworganisations";
                return axios
                    .get(url)
                    .then(response => {
                        this.interviewOrganisations = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            loadCourtRegistries: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "courtRegistries";
                return axios
                    .get(url)
                    .then(response => {
                        this.courtRegistries = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            loadCourtLocations: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "courtlocations/" + this.courtRegistryId;
                return axios
                    .get(url)
                    .then(response => {
                        this.courtLocations = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            loadTimeZones: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "timeZones/";
                if (this.courtLocationId != null) {
                    url += this.courtLocationId;
                }
                return axios
                    .get(url)
                    .then(response => {
                        this.timeZones = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            timeZoneSelectionChanged: function () {
                this.filtersChanged = true;
            },
            loadSkillLevels: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "skilllevel/";
                return axios
                    .get(url)
                    .then(response => {
                        this.skillLevels = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            courtRegistrySelectionChanged: function () {
                this.courtLocationId = null;
                if (this.courtRegistryId) {
                    this.courtRegistryDisplayString = (this.courtRegistries.find(x => x.courtRegistryId === this.courtRegistryId)).name;
                    this.loadCourtLocations();
                } else {
                    this.courtLocations = null;
                    this.courtRegistryDisplayString = '';
                }
                this.filtersChanged = true;
            },
            getEntityDisplayString: function () {
                if (this.courtRegistryId) return this.courtRegistryDisplayString;
                if (this.interviewOrganisationId) return this.interviewOrganisationDisplayString;
                return 'no filter';
            },
            interviewOrganisationSelectionChanged: function () {
                if (this.interviewOrganisationId) {
                    this.interviewOrganisationDisplayString = (this.interviewOrganisations.find(x => x.interviewOrganisationId === this.interviewOrganisationId)).name;
                } else {
                    this.interviewOrganisationDisplayString = '';
                }
                this.filtersChanged = true;
            },
            courtLocationSelectionChanged: function () {
                this.timeZoneId = null;
                this.loadTimeZones();
                this.filtersChanged = true;
            },
            employmentTypeSelectionChanged: function () {
                this.filtersChanged = true;
            },
            skillLevelSelectionChanged: function () {
                this.filtersChanged = true;
            },
            isCurrentWeek: function (week) {
                var now = new Date();
                return (now >= week.startDate) && (now <= week.endDate)
            },
            loadEmploymentTypes: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "employmenttypes/";
                return axios
                    .get(url)
                    .then(response => {
                        this.employmentTypes = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            loadAvailability: function () {

                this.showSpinner = true;
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "weeksaccumulated"
                if (this.startWeek != null) {
                    url += '/';
                    url += this.startWeek.year;
                    url += '/';
                    url += this.startWeek.weekNr;
                }
                var filters = {
                    timeRange: this.selectedTimeRangeFilter,
                    employmentType: this.selectedEmploymentType,
                    typistSkillLevel: this.selectedSkillLevel,
                    courtRegistryId: this.courtRegistryId,
                    interviewOrganisationId: this.interviewOrganisationId,
                    timezoneId: this.timeZoneId
                }
                // to make sure to only pass in APPLIED filters to the Availability Day Accumulated
                this.appliedEmploymentType = this.selectedEmploymentType;
                this.appliedSkillLevel = this.selectedSkillLevel;
                // hard coded to indicate 24 hours - FRAGE - this makes sure that WHOLE day availability is loaded in Modal
                this.appliedTimeRangeFilter = "1"; 
                this.appliedCourtRegistryId = this.courtRegistryId;
                this.appliedInterviewOrganisationId = this.interviewOrganisationId;
                this.appliedEntityDisplayString = this.getEntityDisplayString();

                axios
                    .post(url, JSON.stringify(filters), //this will become a post request that sends the filters as the body
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        this.$bvToast.toast('Availability loaded successfully', {
                            title: 'Weekly Accumulated Availability',
                            variant: 'success',
                            appendToast: true
                        });
                        this.availabilityWeeksAccumulated = response.data;
                        //here we convert all date values to actual date values (they are returned in the JSON as string)
                        this.availabilityWeeksAccumulated.weeks = this.availabilityWeeksAccumulated.weeks.map((week) => {
                            week.startDate = this.parseDateTime(week.startDate, null, true, true);
                            week.endDate = this.parseDateTime(week.endDate, null, true, true);
                            week.days = week.days.map((day) => {
                                day.date = this.parseDateTime(day.date, null, true, true);
                                return day;
                            });
                            return week;
                        });
                        this.showSpinner = false;
                        this.filtersChanged = false;
                    })
                    .catch(ex => {
                        this.showSpinner = false;
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            isRoleRelevant: function (roleId) {
                var role = this.relevantRoles.find(r => r.roleId == roleId);
                return (role != null);
            },
            
            getAvailabilityLevelVariant: function (availabilityLevel) {
                switch (availabilityLevel) {
                    case 0:
                        return 'danger';
                    case 1:
                        return 'warning';
                    default:
                        return 'primary';
                }
            },

            /* FRAGE - obsolte ???
            loadDayByRoleAvailability: function (roleId, date) {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += "timeslotsbydaybyrole/" + this.formatDateTime(date, 'DD/MM/YYYY', true, true) + "/" + roleId;

                var filters = {
                    timeRange: this.selectedTimeRangeFilter,
                    employmentType: this.selectedEmploymentType,
                    sillLevel: this.selectedSkillLevel,
                    courtRegistryId: this.courtRegistryId,
                    interviewOrganisationId: this.interviewOrganisationId,
                    timezoneId: this.timeZoneId
                }

                axios
                    .post(url, JSON.stringify(filters),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        this.dayByRoleAvailability = response.data;
                        this.$refs['availabilityByRoleModal'].show()
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            */

            showDayAccumulatedModal: function (roleId, date) {
                this.checkedRoles = (roleId == null) ? null : [roleId];
                this.modalTitle = "Accumulated Staff Availability";
                this.dateToShow = this.parseDateTime(date, null, true, true);
                this.showDayModal = true;
            },

            showOptionsAccumulatedModal: function (typeOfView,date) {

                if (typeOfView == 'delayedMinutesView') {
                    this.checkedRoles = [16, 32, 128, 256];
                    this.modalTitle = "Accumulated Availability Minutes";
                    this.onlyCheckOptions = false;
                }
                if (typeOfView == 'optionsView') {
                    this.checkedRoles = [16, 64];
                    this.modalTitle = "Accumulated Availablity Options";
                    this.onlyCheckOptions = true;
                }
                
                this.dateToShow = this.parseDateTime(date, null, true, true);
                this.showOptionsModal = true;
            },

            radioChanged(value) {
                if (value == 'court') this.interviewOrganisationId = null;
                if (value == 'interview') {
                    this.courtRegistryId = null;
                    this.courtLocationId = null;
                }
                this.loadTimeZones();
                this.filtersChanged = true;
            }
        },

        mounted: function () {

            this.showSpinner = true;
            var promises = [];
            promises.push(this.loadTimeRangeFilters());
            promises.push(this.loadEmploymentTypes());
            promises.push(this.loadSkillLevels());
            promises.push(this.loadCourtRegistries());
            promises.push(this.loadInterviewOrganisations());
            promises.push(this.loadTimeZones());

            Promise
                .all(promises)
                .then(() => {
                    this.loadAvailability();
                });
        }
    }
</script>

<style scoped>
    div >>> .smaller {
        font-size: 80%;
    }
</style>
